module.exports = __webpack_public_path__ + "static/media/master_card.b880f373.jpg";